export const workerConfigProviderRTTI = Symbol.for("WorkerConfigProvider");
export const setWorkerConfigRTTI = Symbol.for("setWorkerConfig");
